import {
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED,
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START,
  EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS
} from "../actions";

const exportCustomersReportReducer = (state = {}, action) => {
  switch (action.type) {
    case EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START:
      return { ...state, inProgress: false, internalInvoicesInProgress: true };
    case EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS:
      return {
        ...state,
        customersReport: action.payload,
        inProgress: false,
        internalInvoicesInProgress: false,
        errors: []
      };
    case EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED:
    default:
      return {
        ...state,
        customersReport: "",
        inProgress: false,
        internalInvoicesInProgress: false,
        errors: action.errors
      };
  }
};

export default exportCustomersReportReducer;
